import React, { useEffect, useState } from "react";
import axios from "axios";
import endPoint from "../websitecomponents/redux/EndPoint/endpoint";
import { useNavigate } from "react-router-dom";

const SellerProfile = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    console.log("profile", profile)

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        const token = localStorage.getItem("SellerTokenData");
        if (!token) return;

        try {
            setLoading(true);
            const res = await axios.get(endPoint.SellerProfile, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setProfile(res.data.seller);
            setLoading(false);
        } catch {
            setLoading(false);
        }
    };

    if (loading) return <p className="px-6 py-6 text-base">Loading...</p>;

    return (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
            {profile && (
                <form className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
                    {/* Basic Details */}
                    <ReadOnlyInput label="Full Name" value={profile.fullName} />
                    <ReadOnlyInput label="Phone Number" value={profile.phone} />
                    <ReadOnlyInput label="Shop Name" value={profile.shopName} />
                    <ReadOnlyInput label="GST Number" value={profile.gstNumber} />
                    <div className="md:col-span-2">
                        <ReadOnlyInput
                            label="Business Address"
                            value={profile.businessAddress}
                        />
                    </div>

                    {/* Bank Details */}
                    <h3 className="md:col-span-2 text-lg font-semibold mt-8">
                        Bank Account Details
                    </h3>

                    <ReadOnlyInput
                        label="Account Holder Name"
                        value={profile.bankDetails?.holderName}
                    />
                    <ReadOnlyInput
                        label="Account Number"
                        value={profile.bankDetails?.accountNumber}
                    />
                    <ReadOnlyInput
                        label="IFSC Code"
                        value={profile.bankDetails?.ifscCode}
                    />
                    <ReadOnlyInput
                        label="Bank Name"
                        value={profile.bankDetails?.bankName}
                    />

                    <div className="md:col-span-2 flex justify-start mt-6">
                        <button
                            type="button"
                            onClick={() => navigate("/seller/editProfile")}
                            className="px-6 py-3 bg-orange-600 text-white text-base rounded-lg hover:bg-orange-700"
                        >
                            Edit Profile
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

const ReadOnlyInput = ({ label, value }) => (
    <div>
        <p className="text-sm sm:text-base text-gray-500 mb-1">{label}</p>
        <input
            type="text"
            value={value || ""}
            readOnly
            className="w-full border-b border-gray-300 py-2 text-base bg-gray-50 focus:outline-none"
        />
    </div>
);

export default SellerProfile;
